import { httpPost, httpGetWithAuth, httpGet } from "../../axios/axiosUtils";

import {
  ReceiverData,
  OrderResponse,
  AddressInterface,
  IPLACE_ORDER_REQ,
  IRESAllData,
} from "../../shared/commonUtils";
import { useState, useRef } from "react";
// import useBussinessPage from "../useBussiness";
import { URL_CONSTANTS } from "../../axios/urlsLinkRjs";
import { useParams } from "react-router-dom";
import {
  getBussinessData,
  getCustomerInfoFromStroge,
  showSuccesstMessage,
} from "../../shared/helpersMethod";
import cogoToast from "cogo-toast";
import useGetToken from "../useGetToken";

const useCustomerInfo = () => {
  // const { getUserToken, userToken } = useBussinessPage();
  // const shopInfo = useSelector((state) => state.shopInfo);
  const [loading, setLoading] = useState(false);
  const [apiErrorMessage, setErrorMessage] = useState<string>("");
  const [couponLoader, setCouponLoader] = useState<boolean>(false);
  // const [success, setSuccess] = useState<number>(0);
  const [orderPlaced, setOrderPlaced] = useState<OrderResponse>();
  const [receiverInfo, setReceiverInfo] = useState<ReceiverData[]>([]);
  const [trackOrderVal, setTrackOrderVal] = useState<any>();
  // const [cutomerData,setCustomerData] = useState<any>();
  const [userAddress, setUserAddress] = useState<AddressInterface>(
    {} as AddressInterface
  );
  const { getToken } = useGetToken();

  // Prevent multiple simultaneous API calls
  const apiCallInProgress = useRef(false);

  const customerInfo = getCustomerInfoFromStroge();

  const getCustomerInfo = async (
    mobile_number: string,
    name: string,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return { exsitingUser: false, cutomerData: {} };
    }

    let bussinessToken = getBussinessData();
    if (!bussinessToken?.accessToken) {
      try {
        await getToken();
        bussinessToken = getBussinessData();
        if (!bussinessToken?.accessToken) {
          return { exsitingUser: false, cutomerData: {} };
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return { exsitingUser: false, cutomerData: {} };
      }
    }

    var exsitingUser: boolean = false;
    var cutomerData: any = {};

    apiCallInProgress.current = true;
    setLoading(true);

    try {
      const res: IRESAllData = await httpPost(
        URL_CONSTANTS.get("URL_Create_Customer")!,
        {
          mobile_number,
          name,
        },
        {},
        bussinessToken.accessToken
      );

      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          return getCustomerInfo(mobile_number, name, true);
        }
        return { exsitingUser: false, cutomerData: {} };
      }

      console.log(res);
      // setCustomerData(res.data)
      cutomerData = res.data;
      if (res.data.new_user === true) {
        exsitingUser = true;
      } else {
        exsitingUser = false;
      }
    } catch (error: any) {
      console.log(error.message);
      // alert(error.message);
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
    return { exsitingUser, cutomerData };
  };

  const getOrderForCustometDiscountId = async (
    custId: string,
    discountId: string,
    access_token: string,
    discountCode?: string,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return [];
    }

    var orderDetails = [];
    try {
      if (discountCode) {
        setCouponLoader(true);
      }
      // setLoading(true);
      const response: IRESAllData = await httpGetWithAuth(
        URL_CONSTANTS.get("URL_GET,Customer_Discount")! +
          `custId=${custId}&discountId=${discountId}${
            discountCode ? `&discountCode=${discountCode}` : ""
          }`,
        {},
        access_token
      );

      if (response.type === "error" && response?.token === "expired") {
        const newToken = await getToken(true);
        if (newToken) {
          const newBusinessData = getBussinessData();
          return getOrderForCustometDiscountId(
            custId,
            discountId,
            newBusinessData.accessToken,
            discountCode,
            true
          );
        }
        return [];
      }

      if (response.type === "success") {
        orderDetails = response?.data?.orderDetails;
        // if (discountCode) {
        orderDetails = response?.data;
        // }
        setCouponLoader(false);
        // setLoading(false);
      }
      setCouponLoader(false);
      // setLoading(false);
      return orderDetails;
    } catch (error) {
      setCouponLoader(false);
      // setLoading(false);
    }
  };

  const loadReceipent = async (retryAfterTokenRefresh = false) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return;
    }

    let bussinessToken = getBussinessData();
    if (!bussinessToken?.accessToken) {
      try {
        await getToken();
        bussinessToken = getBussinessData();
        if (!bussinessToken?.accessToken) {
          return;
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return;
      }
    }

    if (null !== customerInfo) {
      apiCallInProgress.current = true;
      setLoading(true);
      try {
        const res: IRESAllData = await httpPost(
          URL_CONSTANTS.get("URL_Load_Recipients")!,
          {
            customer_id: customerInfo?.id,
          },
          {},
          bussinessToken.accessToken
        );

        if (res.type === "error" && res?.token === "expired") {
          apiCallInProgress.current = false;
          const newToken = await getToken(true);
          if (newToken) {
            return loadReceipent(true);
          }
          return;
        }

        // console.log(res);
        if (res.type === "success") {
          setReceiverInfo(res.data);
        }
        if (res.type === "error") {
          setReceiverInfo([]);
        }
      } catch (error: any) {
        console.log(error.message);
      } finally {
        setLoading(false);
        apiCallInProgress.current = false;
      }
    }
  };

  const loadAddress = async (
    customer_id: number,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return;
    }

    let bussinessToken = getBussinessData();
    if (!bussinessToken?.accessToken) {
      try {
        await getToken();
        bussinessToken = getBussinessData();
        if (!bussinessToken?.accessToken) {
          return;
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return;
      }
    }

    apiCallInProgress.current = true;
    setLoading(true);
    try {
      const res: IRESAllData = await httpPost(
        URL_CONSTANTS.get("URL_Load_Address")!,
        {
          customer_id,
        },
        {},
        bussinessToken.accessToken
      );

      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          return loadAddress(customer_id, true);
        }
        return;
      }

      // console.log(res);
      if (res.type === "success") {
        setUserAddress(res.data);
      }
    } catch (error: any) {
      console.log(error.message);
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
  };

  const saveNewAddress = async (
    customer_id: number,
    instructions: string,
    address_label: string,
    location: string,
    address: string,
    latlng: any,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return { success: false, data: {} };
    }

    let bussinessToken = getBussinessData();
    if (!bussinessToken?.accessToken) {
      try {
        await getToken();
        bussinessToken = getBussinessData();
        if (!bussinessToken?.accessToken) {
          return { success: false, data: {} };
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return { success: false, data: {} };
      }
    }

    var success: boolean = false;
    var data: any = {};

    apiCallInProgress.current = true;
    setLoading(true);
    try {
      const res: IRESAllData = await httpPost(
        URL_CONSTANTS.get("URL_Save_Address")!,
        {
          customer_id,
          instructions,
          address_label,
          location,
          address,
          latlng,
        },
        {},
        bussinessToken.accessToken
      );

      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          return saveNewAddress(
            customer_id,
            instructions,
            address_label,
            location,
            address,
            latlng,
            true
          );
        }
        return { success: false, data: {} };
      }

      if (res.type === "success") {
        success = true;
        data = res.data;
      } else {
        success = false;
      }
    } catch (error: any) {
      success = false;
      console.log(error.message);
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
    return { success, data };
  };

  const saveNewReceipent = async (
    recipient_name: string,
    recipient_phone: string,
    message?: string,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return { success: false, newId: 0 };
    }

    let bussinessToken = getBussinessData();
    if (!bussinessToken?.accessToken) {
      try {
        await getToken();
        bussinessToken = getBussinessData();
        if (!bussinessToken?.accessToken) {
          return { success: false, newId: 0 };
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return { success: false, newId: 0 };
      }
    }

    var success = false;
    var newId = 0;

    apiCallInProgress.current = true;
    setLoading(true);
    try {
      const res: IRESAllData = await httpPost(
        URL_CONSTANTS.get("URL_Save_Recipient")!,
        {
          recipient_name,
          recipient_phone,
          customer_id: customerInfo?.id,
          message,
        },
        {},
        bussinessToken.accessToken
      );

      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          return saveNewReceipent(
            recipient_name,
            recipient_phone,
            message,
            true
          );
        }
        return { success: false, newId: 0 };
      }

      if (res.type === "success") {
        success = true;
        newId = res.data.recipient_id;
        // setReceiverInfo(res.data);
      } else {
        success = false;
      }
    } catch (error: any) {
      success = false;
      // console.log(error.message);
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
    return { success, newId };
  };

  const saveNewGreetingMessage = async (
    access_token: any,
    reciever_id: string,
    customer_id: string,
    greeting_message: string,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return { success: false };
    }

    var success = false;
    var messageId = 0;

    apiCallInProgress.current = true;
    setLoading(true);
    try {
      const res: IRESAllData = await httpPost(
        URL_CONSTANTS.get("URL_Save_Greeting_Message")!,
        {
          customer_id,
          reciever_id,
          greeting_message,
        },
        {},
        access_token
      );

      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          const newBusinessData = getBussinessData();
          return saveNewGreetingMessage(
            newBusinessData.accessToken,
            reciever_id,
            customer_id,
            greeting_message,
            true
          );
        }
        return { success: false };
      }

      console.log(res);
      if (res.type === "success") {
        success = true;
        return { success };
        // setReceiverInfo(res.data);
      } else {
        success = false;
        return { success };
      }
    } catch (error: any) {
      console.log(error.message);
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
  };

  const updateOrderStatus = async (
    orderId: string,
    orderRef: string,
    orderStatus: string,
    access_token: string,
    retryAfterTokenRefresh = false
  ) => {
    try {
      const res: IRESAllData = await httpPost(
        URL_CONSTANTS.get("URL_POST_UPDATE_ORDER")!,
        {
          id: orderId,
          ref: orderRef,
          orderStatus: orderStatus,
        },
        {},
        access_token
      );

      if (res.type === "error" && res?.token === "expired") {
        const newToken = await getToken(true);
        if (newToken) {
          const newBusinessData = getBussinessData();
          return updateOrderStatus(
            orderId,
            orderRef,
            orderStatus,
            newBusinessData.accessToken,
            true
          );
        }
      }

      // if (res.token === "expired") {
      //   await getUserToken("/" + bussinessName!, true).then((token) => {
      //     if (token) {
      //       updateOrderStatus(orderId, orderRef, orderStatus, token);
      //     }
      //     // console.log(token);
      //     // http://localhost:3000/test-resto/thankyou?order=26490&ref=1265&payment=card&reason=Success
      //   });
      //   // updateOrderStatus(orderId,orderRef,userToken!);
      // }
    } catch (error) {}
  };

  const updateUserAddress = async (
    addressId: string,
    customerId: string,
    retryAfterTokenRefresh = false
  ) => {
    let bussinessToken = getBussinessData();
    if (!bussinessToken?.accessToken) {
      try {
        await getToken();
        bussinessToken = getBussinessData();
        if (!bussinessToken?.accessToken) {
          return;
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return;
      }
    }

    try {
      const res: IRESAllData = await httpPost(
        URL_CONSTANTS.get("URL_Update_Address")!,
        {
          address_id: addressId,
          customer_id: customerId,
        },
        {},
        bussinessToken.accessToken
      );

      if (res.type === "error" && res?.token === "expired") {
        const newToken = await getToken(true);
        if (newToken) {
          return updateUserAddress(addressId, customerId, true);
        }
        return;
      }

      cogoToast.success(res.data.message, { position: "top-center" });
    } catch (error) {}
  };

  const deleteAddress = async (
    address_id: string,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return false;
    }

    let bussinessToken = getBussinessData();
    if (!bussinessToken?.accessToken) {
      try {
        await getToken();
        bussinessToken = getBussinessData();
        if (!bussinessToken?.accessToken) {
          return false;
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return false;
      }
    }

    apiCallInProgress.current = true;
    setLoading(true);
    var success = false;
    try {
      const res: IRESAllData = await httpPost(
        URL_CONSTANTS.get("URL_DELETE_ADDRESS")!,
        {
          address_id,
        },
        {},
        bussinessToken.accessToken
      );

      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          return deleteAddress(address_id, true);
        }
        return false;
      }

      showSuccesstMessage(res.data.message);
      if (res.type === "success") {
        success = true;
        return success;
        // setReceiverInfo(res.data);
      } else {
        success = false;
        return success;
      }
    } catch (error: any) {
      console.log(error.message);
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
  };

  const getCustomerLoyaltyPoints = async (
    customerId: string,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return false;
    }

    let bussinessToken = getBussinessData();
    if (!bussinessToken?.accessToken) {
      try {
        await getToken();
        bussinessToken = getBussinessData();
        if (!bussinessToken?.accessToken) {
          return false;
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return false;
      }
    }

    apiCallInProgress.current = true;
    setLoading(true);
    var success = false;
    try {
      const res: IRESAllData = await httpPost(
        `${URL_CONSTANTS.get("URL_GET_LOYALTY_POINTS")}customer_id=${customerId}`,
        {},
        {},
        bussinessToken.accessToken
      );

      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          return getCustomerLoyaltyPoints(customerId, true);
        }
        return false;
      }

      if (res.type === "success") {
        success = true;
        var response = res;
        return { success, res };
      } else {
        success = false;
        return success;
      }
    } catch (error: any) {
      console.log(error.message);
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
  };

  const deleteReceiver = async (
    receiver_id: number,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return false;
    }

    let bussinessToken = getBussinessData();
    if (!bussinessToken?.accessToken) {
      try {
        await getToken();
        bussinessToken = getBussinessData();
        if (!bussinessToken?.accessToken) {
          return false;
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return false;
      }
    }

    apiCallInProgress.current = true;
    setLoading(true);
    var success = false;
    try {
      const res: IRESAllData = await httpGetWithAuth(
        `${URL_CONSTANTS.get("URL_Delete_Recipient")}${receiver_id}`,
        {},
        bussinessToken.accessToken
      );

      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          return deleteReceiver(receiver_id, true);
        }
        return false;
      }

      console.log(res);
      if (res.type === "success") {
        success = true;
        return success;
        // setReceiverInfo(res.data);
      } else {
        success = false;
        return success;
      }
    } catch (error: any) {
      console.log(error.message);
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
  };

  const placeOrder = async (
    cartValues: IPLACE_ORDER_REQ,
    storeToken: string,
    bussinessName: string,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return { success: false, orderValues: {} };
    }

    // var reqJson = JSON.stringify(cart);
    apiCallInProgress.current = true;
    setLoading(true);
    var success = false;
    var orderValues: any = {};
    try {
      const res: IRESAllData = await httpPost(
        URL_CONSTANTS.get("URL_Confirmed_Order")!,
        {
          ...cartValues,
          // credit card check
        },
        {},
        storeToken
      );

      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          const newBusinessData = getBussinessData();
          return placeOrder(
            cartValues,
            newBusinessData.accessToken,
            bussinessName,
            true
          );
        }
        return { success: false, orderValues: {} };
      }

      if (res.type === "success") {
        setOrderPlaced(res.data);
        success = true;
        orderValues = res.data;
        // setSuccess(1);
      } else {
        setErrorMessage("System unable to process request , Contact support");
      }
      // if (res.token === "expired") {
      //   getUserToken(bussinessName);
      // }
    } catch (e: any) {
      success = false;
      console.log(e);
      //
      setErrorMessage("System unable to process request , Contact support");
      // if(e.response.data.data.errdesc){
      // setErrorMessage(e.response.data.data.errdesc);
      // }
      // setSuccess(2);
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
    return { success, orderValues };
  };

  const trackingOrder = async (
    order_id: string,
    red_if: string,
    selectedLang: string
  ) => {
    setLoading(true);
    try {
      var res = await httpGet(
        `${URL_CONSTANTS.get("URL_Get_TrackOrder")}order=${order_id}&red_if=${red_if}&usrlang=${selectedLang}`
        // access_token
      );
      if (res.type === "success") {
        console.log(res.data);
        setTrackOrderVal(res.data);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  return {
    getCustomerInfo,
    // getValidateCustomer,
    receiverInfo,
    saveNewReceipent,
    updateOrderStatus,
    // cutomerData,
    deleteAddress,
    deleteReceiver,
    saveNewGreetingMessage,
    loadReceipent,
    apiErrorMessage,
    placeOrder,
    getCustomerLoyaltyPoints,
    updateUserAddress,
    couponLoader,
    loadAddress,
    saveNewAddress,
    trackingOrder,
    trackOrderVal,
    getOrderForCustometDiscountId,
    // success,
    orderPlaced,
    userAddress,
    loading,
  };
};
export default useCustomerInfo;
